import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TariffTable from '../components/tables/TariffTable.tsx';

export default function TariffPage() {
  return (
    <Box sx={{ p: '0 1.5rem 2.5rem', width: '75vw', margin: '0 auto', boxSizing: 'border-box' }}>

      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={{
          fontFamily: "'Syne', sans-serif",
          fontSize: 20,
          fontWeight: 600,
          color: '#1D9E75',
          mb: 3,
        }}>
          Tariffs
        </Typography>
      </Box>

      {/* Grid */}
      <Box sx={{ background: 'var(--color-bg-secondary)', borderRadius: 3, p: '1.25rem' }}>
        <TariffTable />
      </Box>
    </Box>
  );
}
